export default {
  heading: "設定新密碼",
  intro: "請為您的教城帳戶{id}設定新密碼。",
  submitBtn: "確定",
  resetBtn: "重設",
  closeBtn: "關閉",
  completed:
    "您已成功設定新密碼。",
  recordNotFound: "很抱歉，您輸入的網址有誤。<br>請檢查網址連結是否正確。如需協助，請電郵至 <a href=\"mailto:support{'@'}edcity.hk\" target=\"_top\">support{'@'}edcity.hk</a> 。",
  backToHome: "返回主頁",
  hasChanged: "您已利用此連結設定新密碼。連結已失效。",
  expired: "連結已超時失效。",
  userNotFound: "系統找不到您的帳戶，請聯繫您的學校管理員檢查帳戶。",

};
